/**
import analyticsMixin from "@/mixins/analytics";
mixins: [analyticsMixin],
 */

import { prefixUtms } from '@/utils/utm.js'
import { OnboardingService } from '@/services/onboarding.service';

export default {
  mounted() {
    if (!window._consentListenersAdded) {
      window._consentListenersAdded = true;
      window.addEventListener('consentGiven', this.$_analytics_handleConsentGiven);
      window.addEventListener('consentRevoked', this.$_analytics_handleConsentRevoked);
    }
  },
  
  methods: {
    async $_analytics_handleConsentGiven() {
      await this.$_analytics_track('Consent Given', {});
    },
    
    async $_analytics_handleConsentRevoked() {
      await this.$_analytics_track('Consent Revoked', {});
    },

    async $_analytics_track(event, properties) {
      const [
        { value: deviceDetailsForContext },
        { value: deviceDetails },
        { value: everflowDetails },
        { value: impactDetails },
        { value: voluumDetails },
        { value: fbParams },
        { value: variantAnalytics },
        { value: gclidDetails },
        { value: tbclid },
        { value: deduplicationID },
        { value: customUtmProperties },
        { value: customFtUtmProperties },
        { value: ttclidDetails },
        { value: onboardingPatient },
      ] = await Promise.allSettled([
        this.$store.dispatch('getDeviceDetailsForContext'),
        this.$store.dispatch('getDeviceDetails'),
        this.$store.dispatch('getEverflowDetails'),
        this.$store.dispatch('getImpactId'),
        this.$store.dispatch('getVoluumDetails'),
        this.$store.dispatch('getFBQParams'),
        this.$store.dispatch('getExperimentAnalyticsDetails'),
        this.$store.dispatch('getGclidDetails'),
        this.$store.dispatch('getTbclid'),
        this.$store.dispatch('getDeduplicationID'),
        this.$store.dispatch('getUTMProperties'),
        this.$store.dispatch('getFTUTMProperties'),
        this.$store.dispatch('getTtclidDetails'),
        OnboardingService.getPatientOnboarding()
      ]);

      const referrerData = Object.keys(impactDetails).length > 0 ? impactDetails : everflowDetails;

      const prefixedUtmProperties = prefixUtms(customUtmProperties) || {}
      const prefixedFtUtmProperties = prefixUtms(customFtUtmProperties) || {}

      window.analytics.track(
        event,
        {
          ...properties,
          ...deviceDetailsForContext,
          ...voluumDetails,
          ...fbParams,
          ...variantAnalytics,
          ...gclidDetails,
          tbclid,
          deduplicationID,
          ...prefixedUtmProperties,
          ...prefixedFtUtmProperties,
          onboardingType: onboardingPatient?.data?.non_hrt ? 'Non-HRT' : undefined,
          ...ttclidDetails,
        },
        {
          referrer: referrerData,
          context: {
            ...deviceDetails,
          },
        }
      );
    },

    async $_analytics_page() {
      const [everflowDetails, impactDetails, customUtmProperties, customFtUtmProperties, fbParams, gclidDetails] = await Promise.all([
        this.$store.dispatch('getEverflowDetails'),
        this.$store.dispatch('getImpactId'),
        this.$store.dispatch('getUTMProperties'),
        this.$store.dispatch('getFTUTMProperties'),
        this.$store.dispatch('getFBQParams'),
        this.$store.dispatch('getGclidDetails'),

      ]);

      const referrerData = Object.keys(impactDetails).length > 0 ? impactDetails : everflowDetails;
      const prefixedUtmProperties = prefixUtms(customUtmProperties) || {};
      const prefixedFtUtmProperties = prefixUtms(customFtUtmProperties) || {};

      window.analytics.page(
        {
          referrer: referrerData,
          ...prefixedUtmProperties,
          ...prefixedFtUtmProperties,
          ...fbParams,
          ...gclidDetails
        },
      )
    },
  },
};
